var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04883 1.44922H11.5488V3.78255H9.99327V3.00477H2.60438V13.8937H9.99327V13.1159H11.5488V15.4492H1.04883V1.44922ZM4.93772 9.21024V7.73161H12.4467L10.8472 5.94951L11.9111 4.94922L15.0488 8.44922L11.9111 11.9492L10.8472 10.9489L12.4077 9.21024H4.93772Z",
    fill: "#303C49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.b736db7fecf6734a97dc35fdbc6ee990.svg";
export { ForwardRef as ReactComponent };